import {register} from 'dna-react-ioc'
import {MerchantSelectStore} from '@/stores'
import {MerchantSelectStoreSymbol, MerchantSelectStoreType} from '@/layouts/MainLayout/components'

export const merchantSelectState = () => {
    register<MerchantSelectStoreType>(MerchantSelectStoreSymbol).to(MerchantSelectStore).inSingletonScope()
}
